import React from "react";
import SafeCallComponent from "../LabOrderItem/children/SafeCallComponent";

const LabOrderWaitingForPaymentActions = (props) => {

  return (
    <>
      <div className="flex-column waiting-for-payment-buttons">
          <SafeCallComponent order={props.order} />
      </div>
    </>
  );
};

export default LabOrderWaitingForPaymentActions;
